import React from "react";
import { useTranslation } from "react-i18next";
import { SettingTitleSection } from "./styles";

const SettingTitle = ({ title }) => {

  return <SettingTitleSection>{title}</SettingTitleSection>;
};

export default SettingTitle
